import React from 'react';

import { Language as LanguageIcon } from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  CardActions as MuiCardActions,
  Button,
  Stack,
  styled,
  Typography
} from '@mui/material';
import {
  LittleIconWithText,
  routeDirectory
} from 'modules';
import { useNavigate } from 'react-router-dom';

import { FavoriteInvestorButton } from './components/FavoriteInvestorButton';



const RelativeCard = styled(Card)({
  position: 'relative',
  borderRadius: 5,
  boxShadow:`
    0px 1px 4px rgba(0, 0, 0, 0.01),
    0px 4px 8px rgba(0, 0, 0, 0.02),
    0px 1px 12px rgba(0, 0, 0, 0.12)
  `
});

const AbsoluteBox = styled(Box)({
  position: 'absolute',
  right: 12,
  top: 12
});

const ImageBox = styled(Box)({
  height: 216,
  display: 'flex',
  justifyContent: 'center'
});

const LogoImg = styled('img')(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: 'white',
  objectFit: 'contain',
  maxWidth: '100%'
}));

const CardActions = styled(MuiCardActions)(({ theme }) => ({
  padding: theme.spacing(2)
}));



export interface IProps {
  userId: string;
  logoUrl: string;
  title: string;
  description: string;
  websiteUrl: string;
  isFavorited?: boolean;

  onClickFavorite: () => void;
  onFavoriteError: () => void;
}

export const FC: React.FC<IProps> = props => {
  const navigate = useNavigate();
  return (
    <RelativeCard>
      <AbsoluteBox>
        <FavoriteInvestorButton
          investorUserId={props.userId}
          isFavorited={props.isFavorited}
          onClick={props.onClickFavorite}
          onError={props.onFavoriteError} />
      </AbsoluteBox>

      <ImageBox>
        {props.logoUrl && (
          <LogoImg src={props.logoUrl} />
        )}
      </ImageBox>

      <CardContent>
        <Stack spacing={1}>
          <Typography variant="h3">{props.title}</Typography>

          <LittleIconWithText.FC
            icon={LanguageIcon}
            iconText={props.websiteUrl}
            onClick={() => {
              window.open(props.websiteUrl, '_blank');
            }} />

          <Typography variant="body2">{props.description}</Typography>
        </Stack>
      </CardContent>

      <CardActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => navigate(routeDirectory.investorProfile.path(props.userId))}>
          Learn More
        </Button>
      </CardActions>
    </RelativeCard>
  );
};
